export default {"src":"/_next/static/media/edit-2.44114eaa.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};